export default function (name) {
  return `partials/${name}`;
}
